export const apiTravelRoutes = {
    routeTravel: 'travel/travel'
}